import axios from 'axios'
import moment from 'moment'
// eslint-disable-next-line import/no-cycle
import store from '../store'
// import router from '../router'
import { Message, Loading } from 'element-ui'
import router from '@/router'
import {
  // getSign,
  getTenantId,
  getToken, getTokenExpires, gotoNewWindow,
} from '@/utils/auth'
// import { authUtils } from 'blm-utils'
import { getRequestJudge, setIsReject, getIsReject } from './multiTenantUtil'
// import { customerror as monitor } from '@/utils/monitor' // 监控
let preRefreshToken = ''
// let lodingObj = null

/**
 * 是否执行刷新 token
 * 当前服务端定义的 token 有效期为 2 小时
 * 前端做检查 如果 token 有效期 - 当前时间 < 5 分钟则执行次刷新
 */
const needRefreshToken = () => {
  const token = getToken()
  const expires = getTokenExpires()
  const currentTime = moment().valueOf()

  if ((preRefreshToken !== token) && expires > 0 && ((expires - currentTime) < (5 * 60 * 1000))) {
    preRefreshToken = token
    store.dispatch('RefreshToken')
  }
}

// 创建axios实例
const service = axios.create({
  // baseURL: 'https://vm-test.yueyuechuxing.cn', // api 的 base_url
  timeout: 60000 * 3, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    // lodingObj = Loading.service()
    // removePending(config.url, true)
    // config.cancelToken = new CancelToken((c) => {
    //   pending[config.url] = c
    // })
    // 携带公参
    // const { method = 'get', params = {}, data = {} } = config
    // const signParam = method === 'get' ? params.signParam : data.signParam
    // config.headers._admin_sign = getSign(signParam) // 参数签名值  String
    config.headers._admin_ts = moment().unix() // 时间戳(秒)  long
    config.headers._admin_eid = getTenantId() // 商户ID  long

    const {
      token,
    } = store.getters

    if (token) {
      config.headers._admin_tk = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 是否需要重新跳转到welcome页面
    if (getRequestJudge(config.url)) {
      if (!getIsReject()) {
        Loading.service()
        setTimeout(() => {
          gotoNewWindow()
        }, 2000)
        Message({
          message: '账户租户权限更新，返回首页。',
          type: 'error',
          duration: 2 * 1000,
        })
      }
      setIsReject()
      return Promise.reject()
    }
    return config
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  },
)

// response 拦截器
service.interceptors.response.use(
  (response) => {
    // lodingObj.close()
    // removePending(response.config.url)
    const res = response.data
    if (response.config && response.config.isExport) {
      return response.data
    }
    console.log('interceptors', response)
    // const url = response.config.url
    // return response.data
    if (!res || res.code !== 1) {
      // 暂时注释埋点上报
      // const ext = {
      //   res, // 出参
      //   params: response.config && response.config.data, // 入参
      //   url: response.config.url
      // }
      // monitor('biz error', ext, 114)
      // Auth failed
      // 1006: 网关请求用户鉴权失败 1008:网关请求参数校验失败 1101:网关请求资源访问鉴权失败
      // 7600: 用户 token 未找到

      // 如果有要特殊处理的错误信息的时候
      let errorCode = response.config.headers._che_error_code
      if (errorCode) {
        // eslint-disable-next-line no-nested-ternary
        errorCode = typeof errorCode !== 'object' ? errorCode : errorCode.length ? errorCode : Object.values(errorCode)
      }
      if (errorCode && errorCode.indexOf(res.code) > -1) {
        return Promise.reject(res) // TODO: 这个设计不好，既然是业务代码，就不应该视为异常，应该直接return 而不是reject，后续要改掉
      }
      // 无权限不提示
      if (res.code === 20010) {
        return res
      }

      // 用户未登录 退出登录
      if (res.code === 20004) {
        return store.dispatch('FedLogOut').then(() => {
          location.reload()
        })
      }

      // 车辆资源包无权限
      if (res.code === 50000) {
        router.app.$refreshBack()
        router.push({ path: '/carResourceNoPermission' })
        return
      }

      res.msg && Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000,
      })

      // 导入失败 弹窗提示
      if (res.code === 23023) {
        return res
      }

      return res
    } else {
      needRefreshToken()
      return response.data
    }
  },
  (error) => {
    // 暂时注释埋点上报
    // const ext = {
    //   params: error.config && error.config.data, // 入参
    //   res: error.response && error.response.data // 出参
    // }
    // monitor('communication error', ext, 155)
    // lodingObj.close()
    if (error.message.includes('timeout')) {
      return Promise.reject(error)
    }
    /**
     * 转化响应类型，优化cancel提示
     */
    if (axios.isCancel(error)) {
      return Promise.reject({
        msg: '请勿重复请求',
        code: 90000,
      })
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  },
)

export default service
